import { useEffect, useCallback, useState } from 'react';

import Cookies from 'js-cookie';

export type PreviewType = {
  bucketId: string;
  bucketPath: string;
};

const INFRA_PREVIEW_COOKIE_KEY = 'infraPreview';

const usePreview = () => {
  const [preview, setPreview] = useState<PreviewType>();

  useEffect(() => {
    const previewUnParsed = Cookies.get(INFRA_PREVIEW_COOKIE_KEY);
    const previewFromCookie = JSON.parse(previewUnParsed || '{}');

    if (previewFromCookie.bucketId) {
      setPreview(previewFromCookie);
    }
  }, []);

  const onPreviewResetClick = useCallback(() => {
    Cookies.remove(INFRA_PREVIEW_COOKIE_KEY, {
      path: '/',
    });

    window.history.pushState({}, '', window.location.pathname);
    window.location.reload();
  }, []);

  return {
    preview,
    onPreviewResetClick,
  };
};

export default usePreview;
